import { css } from '@emotion/core';

export const layoutCls = css`
  min-width: 63rem;
`;
